import React, { Suspense } from "react";
import PageSkeleton from 'components/ui/Skeleton/PageSkeleton';

export const withSuspense = (Component, fallback = <PageSkeleton />) => (
    <Suspense fallback={fallback}>
        <Component />
    </Suspense>
);
